import React, { useRef } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import TopUpLimitsPopup from 'apps/auth/components/ga/accounts/popups/TopUpLimitsPopup';
import BasePage from 'apps/auth/components/utils/BasePage';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { copyTextToClipboard } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const HintButton = styled.div`
    margin-left: 2px;
`;

const TopUpByBankTransferPage = (props) => {
    const popupRef = useRef(null);

    const { id, account, topUpLimit, mainLimitText } = useExtra();

    const {
        topUpBankTransferTitle,
        topUpBankTransferDesc,
        detailsTopUp,
        detailsName,
        detailsCopy,
        detailsCode,
        detailsNumber,
        detailsShare,
        detailsShareTitle,
        bankTransferInfoNextButton,
        snackBarMessageAccName,
        snackBarMessageAccNumber,
        snackBarMessageSortCode,
    } = usePageMessages();

    const getListTopUp = (textSecondary, details) => {
        const getDetailsText = () => {
            if (topUpLimit?.unlimited) {
                return <>{details}</>;
            } else {
                return (
                    <Row flex align="center">
                        {`${details} ${topUpLimit?.cur_iso}`}
                        <HintButton>
                            <DiskButton
                                type="button"
                                size="small"
                                variant="tertiary"
                                iconName="info-rounded"
                                iconColor="secondary"
                                raised={false}
                                onClick={() => {
                                    popupRef.current?.open(<TopUpLimitsPopup popupRef={popupRef} isRegBank />);
                                }}
                            />
                        </HintButton>
                    </Row>
                );
            }
        };

        return (
            <Row indent="adaptive-32-48">
                <DetailsItem detailsTitle={textSecondary} detailsText={getDetailsText()} />
            </Row>
        );
    };

    const getList = (textSecondary, details, snackBarMessage) => {
        return (
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={textSecondary}
                    detailsText={details}
                    detailsButton={detailsCopy}
                    detailsButtonClick={(e) => {
                        e.preventDefault();
                        const result = copyTextToClipboard(details);
                        if (result) {
                            props.toggleSnackBar(true, snackBarMessage);
                        }
                    }}
                />
            </Row>
        );
    };

    if (account.accountDetails) {
        return (
            <>
                <CommonPage backUrl={`/auth/ga/pocket/${id}/top-up`} leftCloseIcon hasBottomPanel>
                    <HeaderPanel title={topUpBankTransferTitle} subtitle={topUpBankTransferDesc} />
                    {getListTopUp(detailsTopUp, mainLimitText)}
                    {getList(detailsName, account.accountDetails.name, snackBarMessageAccName)}
                    {getList(detailsCode, account.accountDetails.sortCode, snackBarMessageSortCode)}
                    {getList(detailsNumber, account.accountDetails.number, snackBarMessageAccNumber)}
                    {__isBrowser__ && navigator && navigator.share && (
                        <Button
                            type="button"
                            variant="row"
                            size="tight"
                            caption={detailsShare}
                            onClick={(e) => {
                                e.preventDefault();
                                navigator
                                    .share({
                                        title: detailsShareTitle,
                                        text: account.accountDetails.sharedDetails,
                                    })
                                    .then(() => logInfo('Successful share'))
                                    .catch((error) => logInfo('Error sharing', error));
                            }}
                            negativeMargin
                        />
                    )}
                    <FixedBottomPanel isRightAligned={true}>
                        <Button
                            type="link"
                            href={`/auth/ga/pocket/${id}/top-up/bank-transfer/final-step`}
                            raised={true}
                            size="fit"
                            caption={bankTransferInfoNextButton}
                        />
                    </FixedBottomPanel>
                </CommonPage>
                <PopupNew ref={popupRef} />
            </>
        );
    } else {
        return false;
    }
};

export default connect(null, { toggleSnackBar })(BasePage(TopUpByBankTransferPage));
